var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExamsEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 11 4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3977F4",
  d: "M10.849.42V3.83H.289V.42z"
})));
export { SvgExamsEmpty as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDExIDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMC44NDkgMC40MjA2NDVWMy44Mjg2NEgwLjI4OTAxNlYwLjQyMDY0NUgxMC44NDlaIiBmaWxsPSIjMzk3N0Y0Ii8+Cjwvc3ZnPgo=";